import { Injectable, Signal, signal } from '@angular/core'
import { toObservable } from '@angular/core/rxjs-interop'
import { UserRolesEnum } from '@ui-core/enums/user-roles.enum'
import { UserInterface } from '@ui-core/interfaces/user.interface'
import { Observable } from 'rxjs'

@Injectable({
    providedIn: 'root',
})
export class UserService {
    private _user = signal<UserInterface | null>(null)
    private _roles = signal<string[]>([])
    private _isInitialised = signal<boolean>(false)

    public readonly isInitialised$: Observable<boolean> = toObservable(this._isInitialised)

    public get(): Signal<UserInterface | null> {
        return this._user
    }

    public get roles(): Signal<string[]> {
        return this._roles
    }

    public get isInitialised(): Signal<boolean> {
        return this._isInitialised
    }

    public set(value: UserInterface | null): void {
        this._user.set(value)
        this._isInitialised.set(true)
    }

    public setInitialised(value: boolean): void {
        this._isInitialised.set(value)
    }

    public setRoles(value: string[]): void {
        const mappedRoles = value.filter((role: string) => Object.values(UserRolesEnum).includes(role as UserRolesEnum))
        this._roles.set(mappedRoles)
    }

    public hasRoles(roles: string[]): boolean {
        let result = true

        for (const role of roles) {
            result = this.roles().includes(role)
            if (!result) {
                break
            }
        }

        return result
    }

    public hasAnyRole(roles: string[]): boolean {
        let result = false

        for (const role of roles) {
            result = this.roles().includes(role)

            if (result) {
                break
            }
        }

        return result
    }
}
